import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";

export default function FaqSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          kicker="常见问题"
          title="关于可游漫画网"
          desc="关于游戏资讯与联动情报服务，你可能关心的问题都在这里。"
          align="center"
        />
        <FaqAccordion items={faqs} />
      </div>
    </section>
  );
}